<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  conversation: { type: Object, required: true },
});

const { t } = useI18n();

const STATUS_CLASS = {
  open: 'bg-n-blue-3 text-n-blue-11',
  pending: 'bg-n-violet-3 text-n-violet-11',
  snoozed: 'bg-n-solid-amber text-n-amber-12',
  resolved: 'bg-n-blue-3 text-n-blue-11',
};
const STATUS_ICON = {
  open: 'i-lucide-message-circle',
  pending: 'i-lucide-sparkles',
  snoozed: 'i-lucide-clock',
  resolved: 'i-lucide-check',
};

const status = computed(() => props.conversation.status || 'open');
const assignee = computed(() => props.conversation.meta?.assignee);
</script>

<template>
  <div
    class="flex shrink-0 items-center justify-between gap-3 px-4 text-xs border-b min-h-11 border-n-weak bg-n-background"
  >
    <span
      class="inline-flex items-center gap-1.5 px-2 py-1 rounded whitespace-nowrap"
      :class="STATUS_CLASS[status]"
    >
      <span class="size-3" :class="STATUS_ICON[status]" />
      {{ t(`CHAT_LIST.CHAT_STATUS_FILTER_ITEMS.${status}.TEXT`) }}
    </span>
    <span class="flex min-w-0 items-center gap-1.5 text-n-slate-11">
      <template v-if="assignee">
        <span
          class="i-lucide-user-round size-3.5 shrink-0"
          aria-hidden="true"
        />
        <span
          class="truncate"
          :title="t('CONVERSATION_SIDEBAR.ASSIGNEE_LABEL')"
        >
          {{ assignee.name }}
        </span>
      </template>
      <template v-else>{{
        t('CHAT_LIST.ASSIGNEE_TYPE_TABS.unassigned')
      }}</template>
    </span>
  </div>
</template>
